module.exports = __webpack_public_path__ + "img/9.d9f3fb88.png";